export const services = [
    {
        id: 1,
        title: "Brand Partnerships",
        desc: "Aligning with companies that share the client's values.",
        image: process.env.PUBLIC_URL + '/services/service1.JPG',
        link: "https://www.tiktok.com/@jordansbowers/video/7328521468281769246"
    },
    {
        id: 2,
        title: "Content Creation & Strategy",
        desc: "Curating meaningful interactions through organic & authentic storytelling.",
        image: process.env.PUBLIC_URL + '/services/service2.png',
        link: "https://www.instagram.com/p/C02xWoIMZ_H/"
    },
    {
        id: 3,
        title: "Public Relations",
        desc: "Showcasing our clients talents across various channels via press releases, podcast appearances and more.",
        image: process.env.PUBLIC_URL + '/services/service3.png',
        link: "https://www.instagram.com/reel/C53Qd82LErv/"
    },
    {
        id: 4,
        title: "Influencer Marketing",
        desc: "Amplifying brand's marketing efforts through talent-led messaging.",
        image: process.env.PUBLIC_URL + '/services/service4.png',
        link: "https://www.instagram.com/reel/CvGQC30MMn9/"
    },
    {
        id: 5,
        title: "Professional Development",
        desc: "Assisting clients with building their professional network for future career opportunities.",
        image: process.env.PUBLIC_URL + '/services/service5.png',
        link: ""
    },
    {
        id: 6,
        title: "Philanthropy",
        desc: "Impacting communities both locally and nationally.",
        image: process.env.PUBLIC_URL + '/services/service6.png',
        link: "https://www.instagram.com/p/Cw05hVHpLrZ/"
    },
]